<div class="admin-file-upload">
  <file-upload
    minsize="1KB"
    maxsize="10MB"
    accept=".pdf,.docx,.doc,.png,.jpg,.jpeg"
    multiple="true"
    animation="false"
    [control]="fileUploadControl"
  >
    <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
      <span class="cmn-blue-btn mb-10" type="button" mat-flat-button color="primary"> + Choose File </span>
      <span class="drag-drop-txt" *ngIf="isFileDragDropAvailable">or Drag File in Here</span>
      <span *ngIf="!isFileDragDropAvailable">Click</span>
    </ng-template>
  </file-upload>
</div>
<small *ngIf="hint">{{ hint }}</small>
<file-preview [type]="type" *ngFor="let file of filesControl.value" [file]="file" (delete)="deleteConfirmation($event)"></file-preview>
